import React from 'react';
import YahyaBio from './YahyaBio';

function App() {
  return (
    <div className="App">
      <YahyaBio />
    </div>
  );
}

export default App;